import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/main/Index'),
      children: [
        {
          path: '',
          name: 'Forside',
          component: () => import('@/views/main/Home')
        },
        {
          path: '/search',
          name: 'Søgning',
          component: () => import('@/views/main/Search')
        },
        {
          path: '/documents',
          redirect: '/search'
        },
        {
          path: '/documents/:id',
          name: 'Dokument',
          component: () => import('@/views/main/Document')
        },
        {
          path: '/about',
          name: 'Om ARVID',
          component: () => import('@/views/main/About')
        },
        {
          path: '/signup',
          name: 'Tilmeld',
          component: () => import('@/views/main/Signup')
        },
      ]
    },
    {
      path: '/administration',
      component: () => import('@/views/admin/Admin'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: 'Dashboard',
          component: () => import('@/views/admin/Dashboard')
        },
        {
          path: 'content',
          name: 'Indholdssektoner',
          component: () => import('@/views/admin/ContentManagement')
        },
        {
          path: 'reporting',
          name: 'Rapportering',
          component: () => import('@/views/admin/Reporting')
        },
        {
          path: 'keywords',
          name: 'Taksonomi',
          component: () => import('@/views/admin/Keywords')
        },
        {
          path: 'users',
          name: 'Brugere',
          component: () => import('@/views/admin/Users')
        },
        {
          path: 'newsletter',
          name: 'Nyhedsbrev',
          component: () => import('@/views/admin/Newsletter')
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login')
    },
    {
      path: '/unsubscribe',
      name: 'Unsubscribe',
      component: () => import('@/views/Unsubscribe')
    },
    {
      path: '/newsletter',
      name: 'Newsletter',
      component: () => import('@/views/NewsletterActions')
    },
    {
      path: "/was",
      beforeEnter() {
        window.location.href = "https://www.was.digst.dk/arvid-star-dk";
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  const loggedIn = sessionStorage.getItem('user')
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!loggedIn) {
      next({ name: 'Login', params: {page: to.path}})
    }
    else next()
  }
  else next()
})

export default router
